import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const ModalitiesContext = createContext();

export const useModalities = () => {
    const context = useContext(ModalitiesContext);
    if (!context) {
        throw new Error('useModalities debe estar dentro del proveedor ModalitiesContext')
    }
    return context;
};

export const ModalitiesContextProvider = ({ children }) => {
    const [modalities, setModalities] = useState([])
    const [modal, setModal] = useState(false)

    const getModal = () => {
        setModal(false)
    }

    const getModalities = async () => {
        const { error, data } = await supabase
            .from('modalities')
            .select('id, name')
            .order('name', { ascending: true })
        if (error) throw (error.message)
        setModalities(data)
    }

    const getModality = async (id) => {
        const { error, data } = await supabase
            .from('modalities')
            .select()
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    const createSpecialty = async (formData) => {
        const { error, status, statusText } = await supabase
            .from('modalities')
            .insert(formData)
            .select()
        if (status !== 201) return {
            title: statusText,
            msg: error.message + " Code:[" + error.code + "]",
            icon: 'error',
            code: status
        }
        await getModalities()
        setModal(true)
        return {
            title: statusText,
            msg: "Registro creado correctamente",
            icon: 'success',
            code: status
        }
    }

    const updateSpecialty = async (formData, id) => {
        try {
            const { error, status, statusText } = await supabase
                .from('modalities')
                .update(formData)
                .eq('id', id)
                .select()
            if (status !== 200) return {
                title: statusText,
                msg: error.message + " Code:[" + error.code + "]",
                icon: 'error'
            }
            await getModalities()
            setModal(true)
            return ({
                title: statusText,
                msg: 'Registro actualizado correctamente',
                icon: 'success'
            })
        } catch (e) {
            console.error(e)
        }
    }


    return (
        <ModalitiesContext.Provider value={{
            modalities,
            modal,
            getModalities,
            getModality,
            createSpecialty,
            updateSpecialty,
            getModal
        }}>
            {children}
        </ModalitiesContext.Provider>
    )
}